import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const saveBtn: SxStyle = {
  background: (p) => p.palette.common.white,
};

export const popover: SxStyleFunc<{ marginBottom: boolean }> = ({
  marginBottom,
}) => ({
  marginTop: (p) => p.spacing(marginBottom ? -0.5 : 0.5),
});
